import { observer } from 'mobx-react';
import * as React from 'react';
import { Link } from 'react-router-dom';
import { T } from '../../Translations';

interface Props {
  children: React.ReactNode;
}

const Breadcrumb: React.FC<Props> = ({ children }) => (
  <p className="mb-4 text-sm text-muted-foreground">
    <Link to="/single_sign_on" className="text-primary hover:underline">
      <T kind="Single Sign-On" />
    </Link>{' '}
    / {children}
  </p>
);

export default observer(Breadcrumb);
